import { render, staticRenderFns } from "./WebPartCardDesigner.vue?vue&type=template&id=544cd44a&scoped=true&"
import script from "./WebPartCardDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartCardDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartCardDesigner.vue?vue&type=style&index=0&id=544cd44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544cd44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544cd44a')) {
      api.createRecord('544cd44a', component.options)
    } else {
      api.reload('544cd44a', component.options)
    }
    module.hot.accept("./WebPartCardDesigner.vue?vue&type=template&id=544cd44a&scoped=true&", function () {
      api.rerender('544cd44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartCardDesigner.vue"
export default component.exports